import React from 'react';

export default function Edge({
  width = 88,
  height = 88,
}: {
  width?: number,
  height?: number,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 88 88"
    >
      <path
        fill="url(#edge_paint0_linear)"
        d="M74.996 62.804a28.194 28.194 0 01-3.17 1.417 30.636 30.636 0 01-10.797 1.943c-14.231 0-26.628-9.79-26.628-22.352a9.469 9.469 0 014.941-8.213c-12.872.541-16.18 13.954-16.18 21.813 0 22.22 20.478 24.472 24.89 24.472 2.379 0 5.967-.692 8.12-1.372l.394-.132a38.598 38.598 0 0020.03-15.88 1.203 1.203 0 00-1.6-1.696z"
      />
      <path
        fill="url(#edge_paint1_radial)"
        d="M74.996 62.804a28.194 28.194 0 01-3.17 1.417 30.636 30.636 0 01-10.797 1.943c-14.231 0-26.628-9.79-26.628-22.352a9.469 9.469 0 014.941-8.213c-12.872.541-16.18 13.954-16.18 21.813 0 22.22 20.478 24.472 24.89 24.472 2.379 0 5.967-.692 8.12-1.372l.394-.132a38.598 38.598 0 0020.03-15.88 1.203 1.203 0 00-1.6-1.696z"
        opacity="0.35"
      />
      <path
        fill="url(#edge_paint2_linear)"
        d="M37.3 78.106a23.818 23.818 0 01-6.84-6.418 24.277 24.277 0 018.882-36.09c.938-.441 2.541-1.241 4.673-1.202a9.729 9.729 0 017.727 3.91 9.587 9.587 0 011.912 5.611c0-.063 7.357-23.939-24.06-23.939-13.202 0-24.06 12.53-24.06 23.521a39.143 39.143 0 003.643 16.842 38.496 38.496 0 0047.03 20.183 22.721 22.721 0 01-18.88-2.406l-.027-.012z"
      />
      <path
        fill="url(#edge_paint3_radial)"
        d="M37.3 78.106a23.818 23.818 0 01-6.84-6.418 24.277 24.277 0 018.882-36.09c.938-.441 2.541-1.241 4.673-1.202a9.729 9.729 0 017.727 3.91 9.587 9.587 0 011.912 5.611c0-.063 7.357-23.939-24.06-23.939-13.202 0-24.06 12.53-24.06 23.521a39.143 39.143 0 003.643 16.842 38.496 38.496 0 0047.03 20.183 22.721 22.721 0 01-18.88-2.406l-.027-.012z"
        opacity="0.41"
      />
      <path
        fill="url(#edge_paint4_radial)"
        d="M51.315 50.27c-.244.315-.993.751-.993 1.701 0 .785.512 1.54 1.42 2.175 4.325 3.007 12.478 2.61 12.499 2.61a17.913 17.913 0 009.103-2.51 18.46 18.46 0 009.152-15.904c.079-6.74-2.406-11.221-3.41-13.206C72.713 12.67 58.956 5.5 43.998 5.5A38.495 38.495 0 005.502 43.454C5.646 32.465 16.57 23.59 29.562 23.59c1.052 0 7.055.102 12.631 3.029 4.914 2.58 7.489 5.696 9.278 8.784 1.859 3.21 2.19 7.263 2.19 8.878 0 1.615-.824 4.01-2.346 5.988z"
      />
      <path
        fill="url(#edge_paint5_radial)"
        d="M51.315 50.27c-.244.315-.993.751-.993 1.701 0 .785.512 1.54 1.42 2.175 4.325 3.007 12.478 2.61 12.499 2.61a17.913 17.913 0 009.103-2.51 18.46 18.46 0 009.152-15.904c.079-6.74-2.406-11.221-3.41-13.206C72.713 12.67 58.956 5.5 43.998 5.5A38.495 38.495 0 005.502 43.454C5.646 32.465 16.57 23.59 29.562 23.59c1.052 0 7.055.102 12.631 3.029 4.914 2.58 7.489 5.696 9.278 8.784 1.859 3.21 2.19 7.263 2.19 8.878 0 1.615-.824 4.01-2.346 5.988z"
      />
      <defs>
        <linearGradient
          id="edge_paint0_linear"
          x1="23.162"
          x2="76.797"
          y1="58.747"
          y2="58.747"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0C59A4" />
          <stop offset="1" stopColor="#114A8B" />
        </linearGradient>
        <radialGradient
          id="edge_paint1_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(28.6853 0 0 27.251 52.786 59.17)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.72" stopOpacity="0" />
          <stop offset="0.95" stopOpacity="0.53" />
          <stop offset="1" />
        </radialGradient>
        <linearGradient
          id="edge_paint2_linear"
          x1="51.438"
          x2="17.938"
          y1="35.481"
          y2="71.971"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B9DE2" />
          <stop offset="0.16" stopColor="#1595DF" />
          <stop offset="0.67" stopColor="#0680D7" />
          <stop offset="1" stopColor="#0078D4" />
        </linearGradient>
        <radialGradient
          id="edge_paint3_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(6.46182 -42.64825 34.45545 5.2205 26.733 65.351)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.76" stopOpacity="0" />
          <stop offset="0.95" stopOpacity="0.5" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="edge_paint4_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-2.4352 60.88032 -129.66231 -5.18647 13.28 19.748)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#35C1F1" />
          <stop offset="0.11" stopColor="#34C1ED" />
          <stop offset="0.23" stopColor="#2FC2DF" />
          <stop offset="0.31" stopColor="#2BC3D2" />
          <stop offset="0.67" stopColor="#36C752" />
        </radialGradient>
        <radialGradient
          id="edge_paint5_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(73.74 19.665 66.192) scale(29.2747 23.8062)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#66EB6E" />
          <stop offset="1" stopColor="#66EB6E" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
}
